export type DiffSeg = { value: string; type: "keep" | "del" | "ins" };

// Word-level diff (LCS) for rendering a tutor correction: original → corrected.
// Tokenizes on words + whitespace so spacing is preserved in the output.
export function wordDiff(original: string, corrected: string): DiffSeg[] {
  const a = original.match(/\S+|\s+/g) ?? [];
  const b = corrected.match(/\S+|\s+/g) ?? [];
  const m = a.length;
  const n = b.length;

  // dp[i][j] = LCS length of a[i:] and b[j:]
  const dp: number[][] = Array.from({ length: m + 1 }, () => new Array(n + 1).fill(0));
  for (let i = m - 1; i >= 0; i--) {
    for (let j = n - 1; j >= 0; j--) {
      dp[i][j] = a[i] === b[j] ? dp[i + 1][j + 1] + 1 : Math.max(dp[i + 1][j], dp[i][j + 1]);
    }
  }

  const segs: DiffSeg[] = [];
  const push = (type: DiffSeg["type"], value: string) => {
    const last = segs[segs.length - 1];
    if (last && last.type === type) last.value += value;
    else segs.push({ type, value });
  };

  let i = 0;
  let j = 0;
  while (i < m && j < n) {
    if (a[i] === b[j]) {
      push("keep", a[i]);
      i++;
      j++;
    } else if (dp[i + 1][j] >= dp[i][j + 1]) {
      push("del", a[i]);
      i++;
    } else {
      push("ins", b[j]);
      j++;
    }
  }
  while (i < m) push("del", a[i++]);
  while (j < n) push("ins", b[j++]);
  return segs;
}
